import { Cart } from 'types/cart.types';
import { OfferItemType } from 'types/offer.types';
import { PlanContractType } from 'types/plan.types';

export const getIsFinanceContractType = (cart: Cart) => {
  return cart?.items.some(
    item => item.offerItem?.type === OfferItemType.Main && item.offerItem?.contractType === PlanContractType.Finance
  );
};
